import { BoutonSecondaire } from './Champ';

/**
 * Le choix d'un mois, par flèches.
 *
 * Un mois se choisit presque toujours de proche en proche : le mois dernier,
 * celui d'avant. Deux clics valent mieux qu'une saisie « AAAA-MM », qui oblige
 * à taper un format, et qui sur mobile ouvre un clavier pour écrire un nombre
 * que l'écran connaît déjà. C'est le modèle des calendriers, retenu comme
 * modèle commun (recette du Lot 7, point 10).
 *
 * La valeur reste au format « AAAA-MM » : c'est ce que parlent les routes.
 */
const MOIS = [
  'janvier',
  'février',
  'mars',
  'avril',
  'mai',
  'juin',
  'juillet',
  'août',
  'septembre',
  'octobre',
  'novembre',
  'décembre',
];

/** « 2026-07 » → « juillet 2026 ». */
export function libelleMois(mois: string): string {
  const [a, m] = mois.split('-');
  const i = Number(m) - 1;
  return MOIS[i] ? `${MOIS[i]} ${a}` : mois;
}

/** Le mois d'à côté, en « AAAA-MM ». */
export function moisDecale(mois: string, pas: number): string {
  const annee = Number(mois.slice(0, 4));
  const m = Number(mois.slice(5, 7)) - 1;
  const d = new Date(Date.UTC(annee, m + pas, 1));
  return `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, '0')}`;
}

export function NavigationMois({
  valeur,
  onChange,
  libelle = 'Mois',
}: {
  valeur: string;
  onChange: (mois: string) => void;
  /** Lu par les lecteurs d'écran ; le libellé visible est le mois lui-même. */
  libelle?: string;
}) {
  return (
    <div className="flex items-center gap-2" role="group" aria-label={libelle}>
      <BoutonSecondaire
        type="button"
        className="!px-3"
        aria-label="Mois précédent"
        onClick={() => onChange(moisDecale(valeur, -1))}
      >
        ‹
      </BoutonSecondaire>
      <span className="min-w-40 text-center font-medium capitalize text-nuit">
        {libelleMois(valeur)}
      </span>
      <BoutonSecondaire
        type="button"
        className="!px-3"
        aria-label="Mois suivant"
        onClick={() => onChange(moisDecale(valeur, 1))}
      >
        ›
      </BoutonSecondaire>
    </div>
  );
}
